import React, { useCallback, useEffect, useState } from 'react';
import { Calendar, Clock, Eye, Logs, Plus, Trash, Trophy, Users } from 'lucide-react';
import { GetEventsApi } from '../redux/actions/event-management/GetEventsAction';
import { GetEventsCountApi } from '../redux/actions/event-management/GetEventsCountAction';
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { formatDate } from '../helpers/DateFormatter';
import Pagination from '../components/Pagination';
import Filters from '../components/Filters';
import { useNavigate } from 'react-router-dom';
import { DeleteEventAPI } from '../redux/actions/event-management/DeleteEventAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { deleteEventStateReset } from '../redux/slices/event-management/DeleteEventSlice';
import Swal from 'sweetalert2';
import { StarIcon as FilledStar } from '@heroicons/react/24/solid';
import { StarIcon as OutlineStar } from '@heroicons/react/24/outline';
import { MarkFeatureAPI } from '../redux/actions/event-management/MarkFeatureAction';
import { markFeatureStateReset } from '../redux/slices/event-management/MarkFeatureSlice';
import { backend_url, image_url } from '../services/endpoints';

const EvenetManagement = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { response, loading, error } = useSelector((state) => state.getEventsCount)

    const { response: listResponse, loading: listloading, error: listError } = useSelector((state) => state.getEvents)

    const { response: deleteResponse, loading: deleteLoading, error: deleteError } = useSelector((state) => state.deleteEvent)

    const { response: featuredResponse, loading: featuredLoading, error: featuredError } = useSelector((state) => state.markFeature)

    const [dataList, setDataList] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [items, setItems] = useState(5);
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('');
    const [limit, setLimit] = useState(5);

    const [deleted, setDeleted] = useState(false);
    const [markedAsFeatured, setMakredAsFeatured] = useState(false);
    const [eventType, setEventType] = useState('');
    const [sport, setSport] = useState('');
    const [location, setLocation] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [locationInput, setLocationInput] = useState('');
    const [sportInput, setSportInput] = useState('');
    const [eventTypeInput, setEventTypeInput] = useState('');
    const [statusInput, setStatusInput] = useState('');

    const isTruthy = (value) => value === true || value === 'true';
    const capitalizeFirstLetter = (value) => {
        if (!value) return value;
        return value.charAt(0).toUpperCase() + value.slice(1);
    };
    const getImageUrl = (path, fallback = '/assets/images/dummy-user.png') => {
        if (!path) return fallback;
        if (/^https?:\/\//i.test(path)) return path;
        return `${image_url}${path}`;
    };

    const fetchEvents = useCallback(() => {
        dispatch(GetEventsApi(currentPage, limit, search, sport, eventType, status, location));
    }, [currentPage, limit, search, sport, eventType, status, location, dispatch]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDeleteEvent = async (eventId) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: `You want to delete this event`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await dispatch(DeleteEventAPI({ eventId }));
                    } catch (error) {
                        Swal.fire(error?.response?.message);
                    }
                }
            });

        } catch (error) {
            showErrorToast('error in deleteing event');
        }
    }

    const handleFeature = async (eventId, eventStatus) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: `${eventStatus === true ? 'You want to mark this event as non-featured' : 'You want to mark this event as featured'
                    }`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        let featured_event = '';
                        if (eventStatus === true) {
                            featured_event = false
                        }
                        if (eventStatus === false) {
                            featured_event = true
                        }
                        await dispatch(MarkFeatureAPI({ eventId, featured_event }));
                    } catch (error) {
                        Swal.fire(error?.response?.message);
                    }
                }
            });

        } catch (error) {
            showErrorToast('error in feature event');
        }
    }

    useEffect(() => {
        dispatch(GetEventsCountApi());
    }, [dataList, dispatch])

    useEffect(() => {
        fetchEvents()
    }, [currentPage, limit, search, eventType, status, sport, fetchEvents, location, deleted, markedAsFeatured])

    useEffect(() => {
        if (listResponse?.status === true) {
            setCurrentPage(listResponse?.data?.currentPage);
            setTotalPages(listResponse?.data?.totalPages);
            setItems(listResponse?.data?.setItems);
            setDataList(listResponse?.data?.data);
        }
    }, [listResponse])

    useEffect(() => {
        if (deleteResponse?.status === true) {
            showSuccessToast(deleteResponse?.message);
            dispatch(deleteEventStateReset());
            setDeleted(prev => !prev);
            setCurrentPage(1);
        }
    }, [deleteResponse, dispatch])

    useEffect(() => {
        if (deleteError) {
            showErrorToast(deleteError?.data);
            dispatch(deleteEventStateReset());
        }
    }, [deleteError, dispatch])

    useEffect(() => {
        if (featuredResponse?.status === true) {
            showSuccessToast(featuredResponse?.message);
            dispatch(markFeatureStateReset());
            setMakredAsFeatured(prev => !prev);
            setCurrentPage(1);
        }
    }, [featuredResponse, dispatch])

    useEffect(() => {
        if (featuredError) {
            showErrorToast(featuredError?.data);
            dispatch(markFeatureStateReset());
        }
    }, [featuredError, dispatch])

    return (
        <>
            <div className="page_top_section">
                <div className="page-header">
                    <div className="page-header-left d-flex align-items-center">
                        <div className="page-header-title">
                            <h1 className="fs-3 text-black fw-semibold  mb-0 text-capitalize">Event & Challenge Management</h1>
                            <p className="text-clr mb-0">Manage and monitor all events and challenges on your platform.</p>
                        </div>
                    </div>
                    <div className="page-header-right ms-auto">
                        <div className="page-header-right-items ">
                            <div className="d-flex rtgl-d-none">
                                <button className="page-header-right-close-toggle border-0 bg-transparent" type="button">
                                    <svg stroke="currentColor" fill="none" strokeWidth={2} viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="me-2" height={16} width={16} xmlns="http://www.w3.org/2000/svg">
                                        <line x1={19} y1={12} x2={5} y2={12} />
                                        <polyline points="12 19 5 12 12 5" />
                                    </svg><span>Back</span></button>
                            </div>
                            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                <div className="side-content-blk">
                                    <button className="primary-btn" onClick={() => navigate('/admin-dashboard/create-new-event')}>
                                        <Plus />
                                        <span className="btntext">Create new event</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rtgl-d-none d-flex align-items-center">
                        <button className="page-header-right-open-toggle border-0 bg-transparent" type="button">
                            <Logs />
                        </button>
                    </div>

                </div>
            </div>
            {
                loading || listloading
                    ? (
                        <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center' >
                            <PulseLoader size={25} color="#0f0a30" />
                        </div >
                    ) : error || listError ? (
                        <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                            <p className='text-danger'>Something went wrong</p>
                        </div>
                    ) :
                        <section className="main-section common_section spacer">
                            <div className="container">
                                <div className="row gy-4">
                                    <div className="col-12">
                                        <div className="row gx-4 gy-4">
                                            <div className="col-sm-6 col-md-4 col-xl-3">
                                                <div className="dash-num-info-cards">
                                                    <div className="dash-num-info-cards-header">
                                                        <div className="num-info-content-box">
                                                            <h2>Total Events</h2>
                                                            <span className="num-values">{response?.data?.totalEvents || 0}</span>
                                                        </div>
                                                        <div className="num-info-icon-box">
                                                            <Calendar />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-xl-3">
                                                <div className="dash-num-info-cards">
                                                    <div className="dash-num-info-cards-header">
                                                        <div className="num-info-content-box">
                                                            <h2>Upcoming Events</h2>
                                                            <span className="num-values">{response?.data?.upcomingEvents || 0}</span>
                                                        </div>
                                                        <div className="num-info-icon-box">
                                                            <Clock />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-xl-3">
                                                <div className="dash-num-info-cards">
                                                    <div className="dash-num-info-cards-header">
                                                        <div className="num-info-content-box">
                                                            <h2>Active Challenges</h2>
                                                            <span className="num-values">{response?.data?.activeChallenges || 0}</span>
                                                        </div>
                                                        <div className="num-info-icon-box">
                                                            <Trophy />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-xl-3">
                                                <div className="dash-num-info-cards">
                                                    <div className="dash-num-info-cards-header">
                                                        <div className="num-info-content-box">
                                                            <h2>Total Participants</h2>
                                                            <span className="num-values">{response?.data?.totalParticipants || 0}</span>
                                                        </div>
                                                        <div className="num-info-icon-box">
                                                            <Users />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <filters> */}
                                    {/* <div className="col-12">
                                        <div className="top_filter_block hstack align-items-end flex-wrap gap-3">
                                            <div className="form-group">
                                                <label className="fs-12 fw-semibold mb-1">Search</label>
                                                <div className="input-field">
                                                    <input class="form-control" placeholder="Event name, Description" type="search" value="" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="fs-12 fw-semibold mb-1">Status</label>
                                                <div className="input-field">
                                                    <select className="form-select">
                                                        <option value="">All status</option>
                                                        <option value="Upcoming">Upcoming</option>
                                                        <option value="Ongoing">Ongoing</option>
                                                        <option value="Past">Past</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="fs-12 fw-semibold mb-1">Type</label>
                                                <div className="input-field">
                                                    <select className="form-select">
                                                        <option value="">All Type</option>
                                                        <option value="Event">Event</option>
                                                        <option value="Challenge">Challenge</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="fs-12 fw-semibold mb-1">Sport</label>
                                                <div className="input-field">
                                                    <select className="form-select">
                                                        <option value="">All Sport</option>
                                                        <option value="Football">Football</option>
                                                        <option value="Basketball">Basketball</option>
                                                        <option value="Tennis">Tennis</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="fs-12 fw-semibold mb-1">Location</label>
                                                <div className="input-field">
                                                    <input class="form-control" placeholder="City, venue" type="text" value="" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <button className="primary-btn w-100">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-search" aria-hidden="true">
                                                        <path d="m21 21-4.34-4.34"></path>
                                                        <circle cx="11" cy="11" r="8"></circle>
                                                    </svg><span className="btntext">Search</span></button>
                                            </div>
                                        </div>
                                    </div> */}

                                    <Filters
                                        searchInput={searchInput}
                                        setSearchInput={setSearchInput}
                                        eventTypeInput={eventTypeInput}
                                        setEventTypeInput={setEventTypeInput}
                                        sportInput={sportInput}
                                        setSportInput={setSportInput}
                                        statusInput={statusInput}
                                        setStatusInput={setStatusInput}
                                        locationInput={locationInput}
                                        setLocationInput={setLocationInput}
                                        setSearch={setSearch}
                                        setSport={setSport}
                                        setEventType={setEventType}
                                        setLocation={setLocation}
                                        setStatus={setStatus}
                                        handleSearchClick={(searchValue, statusValue, locationValue, sportValue, eventTypeValue) => {
                                            setSearch(searchValue);
                                            setEventType(eventTypeValue);
                                            setSport(sportValue);
                                            setLocation(locationValue);
                                            setStatus(statusValue)
                                            setCurrentPage(1);
                                        }}
                                    />
                                    {/* </filters> */}
                                    <div className="col-12">
                                        <div className="common-table-wrapper">
                                            <div className="common-table-filter-wrapper">
                                                <div className="common-left-blk">
                                                    <h2 className="fs-5 fw-bold mb-0">Events & Challenges</h2>
                                                </div>
                                                <div className="common-right-blk">
                                                    <div className="common-sort-blk">
                                                        <label className="d-flex align-items-center gap-2">Show:
                                                            <select
                                                                className="form-select"
                                                                value={limit}
                                                                onChange={(e) => {
                                                                    setLimit(Number(e.target.value));
                                                                }}
                                                            >
                                                                <option value={5}>5</option>
                                                                <option value={10}>10</option>
                                                                <option value={15}>15</option>
                                                                <option value={20}>20</option>
                                                            </select>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            {dataList?.length > 0 ? dataList?.map((d, i) => {
                                                return (

                                                    <div className='event_challenge_list' key={i}>
                                                        <div className='event_challenge_item'>
                                                            <div className='ec_cover_img_blk'>
                                                                {d?.cover_image ? (
                                                                    <>
                                                                        <img src={`${backend_url}/uploads/${d?.cover_image}`} alt={d?.title || 'Event cover'} />
                                                                    </>
                                                                ) :
                                                                    <>
                                                                        <span>EC Cover</span>
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className='ec_info_blk'>
                                                                <div className='ec_header_blk'>
                                                                    <h2>{capitalizeFirstLetter(d?.title) || 'N/A'}</h2>
                                                                    <div className='hstack flex-wrap gap-2'>
                                                                        <span className='ec_badges'>{d?.event_type === 'challenge' ? 'Challenge' : 'Event'}</span>
                                                                        {isTruthy(d?.platform_event) ? (
                                                                            <span className='ec_badges'>Platform Event</span>
                                                                        ) : isTruthy(d?.featured_event) ? (
                                                                            <span className='ec_badges'>Featured Event</span>
                                                                        ) : isTruthy(d?.public_event) ? (
                                                                            <span className='ec_badges'>Public Event</span>
                                                                        ) : null}
                                                                        {
                                                                            d?.status && (
                                                                                <span className='ec_badges'>{d?.status}</span>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className='ec_info hstack flex-wrap gap-3 gap-lg-5'>
                                                                    <p><span>Creator:</span>{d?.event_creator_username ? `@${d?.event_creator_username}` : 'N/A'}</p>
                                                                    <p><span>Date:</span>{d?.start_date ? formatDate(d?.start_date) : 'N/A'}</p>
                                                                    <p><span>Location:</span>{d?.location_name || 'N/A'}</p>
                                                                    <div className="ec_participants_preview">
                                                                        <span>Participants:</span>
                                                                        {d?.registred_participants?.length > 0 ? (
                                                                            <>
                                                                                <div className="ec_participant_avatars">
                                                                                    {d.registred_participants.map((participant, index) => (
                                                                                        <img key={participant?.userId || index} src={getImageUrl(participant?.profilePic)} alt={participant?.username || 'Participant'} title={participant?.username || 'Participant'} />
                                                                                    ))}
                                                                                </div>
                                                                                <strong>{d?.registred_participants_count || 0} </strong>
                                                                            </>
                                                                        ) : (
                                                                            <strong>0</strong>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <p className='ec_description'>{d?.description || 'N/A'}</p>
                                                                <div className='ec_action_blk hstack flex-wrap gap-3'>
                                                                    <button className='ec_btns' onClick={() => navigate(`/admin-dashboard/event-detail/${d?._id}`, { state: { eventId: d?._id } })}><Eye /> View & Update</button>
                                                                    <button className='ec_btns' onClick={() => handleFeature(d?._id, isTruthy(d?.featured_event))}>{isTruthy(d?.featured_event) ? <FilledStar /> : <OutlineStar />}{featuredLoading ? <PulseLoader color="#000000" /> : 'Feature'}</button>
                                                                    {/* <button className='ec_btns' disabled><SquarePen /> Edit</button> */}
                                                                    {/* <button className='ec_btns' disabled><Flag /> View Reports</button> */}
                                                                    <button className='ec_btns' onClick={() => {
                                                                        handleDeleteEvent(d?._id)
                                                                    }}><Trash />{deleteLoading ? <PulseLoader color="#000000" /> : 'Delete'}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                )
                                            })
                                                :
                                                <div style={{ textAlign: 'center' }}>No data available</div>
                                            }

                                            <Pagination currentPage={currentPage} totalPages={totalPages} items={items} limit={limit} handlePageChange={handlePageChange} />
                                            {/* <div className="table-pagination">
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination justify-content-end mb-0 gap-2">
                                                        <li className="page-item prev-page disabled">
                                                            <button className="page-link">Previous</button>
                                                        </li>
                                                        <li className="page-item active">
                                                            <button className="page-link">1</button>
                                                        </li>
                                                        <li className="page-item ">
                                                            <button className="page-link">2</button>
                                                        </li>
                                                        <li className="page-item ">
                                                            <button className="page-link">3</button>
                                                        </li>
                                                        <li className="page-item ">
                                                            <button className="page-link">4</button>
                                                        </li>
                                                        <li className="page-item ">
                                                            <button className="page-link">5</button>
                                                        </li>
                                                        <li className="page-item next-page ">
                                                            <button className="page-link">Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

            }
        </>

    )
}

export default EvenetManagement
